/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
//     SourceSHA: 
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { TellerOnlineApiClientBase } from 'teller-online-libraries/core';
import { TellerOnlineWindowService } from "teller-online-libraries/shared";
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, from as _observableFrom, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const ONLINE_IDENTITY_API_BASE_URL = new InjectionToken<string>('ONLINE_IDENTITY_API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class AuthApiClient extends TellerOnlineApiClientBase {
    private http: HttpClient;
    private static _baseUrl: string;
    private get baseUrl() { return AuthApiClient._baseUrl }
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TellerOnlineWindowService) configuration: TellerOnlineWindowService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(ONLINE_IDENTITY_API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        if(!this.baseUrl) AuthApiClient._baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/api/identity";
    }

    static init(baseUrl: string){
        AuthApiClient._baseUrl = baseUrl;
    }

    /**
     * Sign in
     * @param body (optional) 
     * @return OK
     */
    signIn(body: SignInRequestDto | undefined): Observable<SignInResponseDto> {
        let url_ = this.baseUrl + "/auth/sign-in/";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processSignIn(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSignIn(<any>r));
                } catch (e) {
                    return <Observable<SignInResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SignInResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processSignIn(response: HttpResponseBase): Observable<SignInResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SignInResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Sign out
     * @return OK
     */
    signOut(): Observable<void> {
        let url_ = this.baseUrl + "/auth/sign-out/";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processSignOut(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSignOut(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSignOut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get basic auth details for the current session
     * @param body (optional) 
     * @return OK
     */
    getAuthDetails(body: AuthDetailsRequestDto | undefined): Observable<AuthDetailsResponseDto> {
        let url_ = this.baseUrl + "/auth/";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAuthDetails(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAuthDetails(<any>r));
                } catch (e) {
                    return <Observable<AuthDetailsResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AuthDetailsResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAuthDetails(response: HttpResponseBase): Observable<AuthDetailsResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthDetailsResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Initiate the sign up process
     * @param body (optional) 
     * @return OK
     */
    initiateSignUp(body: InitiateSignUpRequestDto | undefined): Observable<InitiateSignUpResponseDto> {
        let url_ = this.baseUrl + "/auth/sign-up/initiate";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processInitiateSignUp(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processInitiateSignUp(<any>r));
                } catch (e) {
                    return <Observable<InitiateSignUpResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<InitiateSignUpResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processInitiateSignUp(response: HttpResponseBase): Observable<InitiateSignUpResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InitiateSignUpResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Confirm the sign up process
     * @param body (optional) 
     * @return OK
     */
    confirmSignUp(body: ConfirmSignUpRequestDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/auth/sign-up/confirm";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processConfirmSignUp(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processConfirmSignUp(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processConfirmSignUp(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Initiate user password reset
     * @param body (optional) 
     * @return OK
     */
    initiatePasswordReset(body: InitiatePasswordResetRequestDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/auth/reset-password/initiate";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processInitiatePasswordReset(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processInitiatePasswordReset(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processInitiatePasswordReset(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Confirms user password reset
     * @param body (optional) 
     * @return OK
     */
    confirmPasswordReset(body: ConfirmPasswordResetRequestDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/auth/reset-password/confirm";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processConfirmPasswordReset(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processConfirmPasswordReset(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processConfirmPasswordReset(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Resend email confirmation code
     * @param body (optional) 
     * @return OK
     */
    resendEmailConfirmationCode(body: ResendEmailConfirmationRequestDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/auth/resend-email-confirmation-code";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processResendEmailConfirmationCode(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processResendEmailConfirmationCode(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processResendEmailConfirmationCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Resend phone confirmation code
     * @return OK
     */
    resendPhoneConfirmationCode(): Observable<void> {
        let url_ = this.baseUrl + "/auth/resend-phone-confirmation-code";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processResendPhoneConfirmationCode(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processResendPhoneConfirmationCode(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processResendPhoneConfirmationCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Confirm phone code
     * @param body (optional) 
     * @return OK
     */
    confirmPhoneCode(body: ConfirmPhoneCodeRequestDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/auth/confirm-phone";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processConfirmPhoneCode(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processConfirmPhoneCode(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processConfirmPhoneCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Confirm email code
     * @param body (optional) 
     * @return OK
     */
    confirmEmailCode(body: ConfirmEmailCodeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/auth/confirm-email";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processConfirmEmailCode(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processConfirmEmailCode(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processConfirmEmailCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Change user password
     * @param body (optional) 
     * @return OK
     */
    changeUserPassword(body: ChangeUserPasswordDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/auth/change-password";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processChangeUserPassword(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processChangeUserPassword(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangeUserPassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UserProfileApiClient extends TellerOnlineApiClientBase {
    private http: HttpClient;
    private static _baseUrl: string;
    private get baseUrl() { return UserProfileApiClient._baseUrl }
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TellerOnlineWindowService) configuration: TellerOnlineWindowService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(ONLINE_IDENTITY_API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        if(!this.baseUrl) UserProfileApiClient._baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/api/identity";
    }

    static init(baseUrl: string){
        UserProfileApiClient._baseUrl = baseUrl;
    }

    /**
     * Get the user profile
     * @return OK
     */
    getUserProfile(): Observable<UserProfileDto> {
        let url_ = this.baseUrl + "/user-profile";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetUserProfile(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetUserProfile(<any>r));
                } catch (e) {
                    return <Observable<UserProfileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserProfileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserProfile(response: HttpResponseBase): Observable<UserProfileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProfileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete the user profile
     * @param body (optional) 
     * @return OK
     */
    deleteUserProfile(body: DeleteUserProfileDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/user-profile";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteUserProfile(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteUserProfile(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteUserProfile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update the user profile
     * @param body (optional) 
     * @return OK
     */
    updateUserProfile(body: UserProfileDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/user-profile/";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdateUserProfile(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdateUserProfile(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateUserProfile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get user profile notifications settings
     * @return OK
     */
    getUserNotificationSettings(): Observable<UserNotificationSettingsDto> {
        let url_ = this.baseUrl + "/user-profile/view-notification-settings";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetUserNotificationSettings(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetUserNotificationSettings(<any>r));
                } catch (e) {
                    return <Observable<UserNotificationSettingsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserNotificationSettingsDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserNotificationSettings(response: HttpResponseBase): Observable<UserNotificationSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserNotificationSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update user profile settings of the user
     * @param body (optional) 
     * @return OK
     */
    updateUserNotificationSettings(body: UserNotificationSettingsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/user-profile/update-notification-settings";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdateUserNotificationSettings(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdateUserNotificationSettings(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateUserNotificationSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get user profile changes history
     * @return OK
     */
    getUserProfileHistory(): Observable<UserProfileHistoryDto[]> {
        let url_ = this.baseUrl + "/user-profile/view-user-profile-history";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetUserProfileHistory(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetUserProfileHistory(<any>r));
                } catch (e) {
                    return <Observable<UserProfileHistoryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserProfileHistoryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserProfileHistory(response: HttpResponseBase): Observable<UserProfileHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserProfileHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

/** Basic auth details */
export class AuthDetailsRequestDto implements IAuthDetailsRequestDto {
    /** If true, will refresh user's auth token as long as their refreshToken has not been revoked. */
    refreshAuthToken?: boolean;

    [key: string]: any;

    constructor(data?: IAuthDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.refreshAuthToken = _data["refreshAuthToken"];
        }
    }

    static fromJS(data: any): AuthDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuthDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["refreshAuthToken"] = this.refreshAuthToken;
        return data;
    }
}

/** Basic auth details */
export interface IAuthDetailsRequestDto {
    /** If true, will refresh user's auth token as long as their refreshToken has not been revoked. */
    refreshAuthToken?: boolean;

    [key: string]: any;
}

/** Basic auth details */
export class AuthDetailsResponseDto implements IAuthDetailsResponseDto {
    /** Identity server user id */
    identityProviderUserId?: string;
    /** Indicates if the user is signed in */
    isSignedIn?: boolean;
    /** The name of the user */
    name?: string;
    /** Email address of the user */
    email?: string;
    /** Time when the user's session is set to expire represented in milliseconds since epoch (1970-01-01) */
    sessionExpiry?: any;

    [key: string]: any;

    constructor(data?: IAuthDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.identityProviderUserId = _data["identityProviderUserId"];
            this.isSignedIn = _data["isSignedIn"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.sessionExpiry = _data["sessionExpiry"];
        }
    }

    static fromJS(data: any): AuthDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuthDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["identityProviderUserId"] = this.identityProviderUserId;
        data["isSignedIn"] = this.isSignedIn;
        data["name"] = this.name;
        data["email"] = this.email;
        data["sessionExpiry"] = this.sessionExpiry;
        return data;
    }
}

/** Basic auth details */
export interface IAuthDetailsResponseDto {
    /** Identity server user id */
    identityProviderUserId?: string;
    /** Indicates if the user is signed in */
    isSignedIn?: boolean;
    /** The name of the user */
    name?: string;
    /** Email address of the user */
    email?: string;
    /** Time when the user's session is set to expire represented in milliseconds since epoch (1970-01-01) */
    sessionExpiry?: any;

    [key: string]: any;
}

export class InitiateSignUpRequestDto implements IInitiateSignUpRequestDto {
    /** Email address for the user account */
    email!: string;
    /** Name for the user account */
    name!: string;
    /** Password */
    password!: string;
    /** Confirm Password */
    confirmPassword!: string;
    /** The token provided by the reCAPTCHA widget */
    captchaToken?: string;

    [key: string]: any;

    constructor(data?: IInitiateSignUpRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.email = _data["email"];
            this.name = _data["name"];
            this.password = _data["password"];
            this.confirmPassword = _data["confirmPassword"];
            this.captchaToken = _data["captchaToken"];
        }
    }

    static fromJS(data: any): InitiateSignUpRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new InitiateSignUpRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["email"] = this.email;
        data["name"] = this.name;
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        data["captchaToken"] = this.captchaToken;
        return data;
    }
}

export interface IInitiateSignUpRequestDto {
    /** Email address for the user account */
    email: string;
    /** Name for the user account */
    name: string;
    /** Password */
    password: string;
    /** Confirm Password */
    confirmPassword: string;
    /** The token provided by the reCAPTCHA widget */
    captchaToken?: string;

    [key: string]: any;
}

export class InitiateSignUpResponseDto implements IInitiateSignUpResponseDto {
    /** The IdentityProviderUserId of the new user (from the external system) */
    identityProviderId?: string;

    [key: string]: any;

    constructor(data?: IInitiateSignUpResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.identityProviderId = _data["identityProviderId"];
        }
    }

    static fromJS(data: any): InitiateSignUpResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new InitiateSignUpResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["identityProviderId"] = this.identityProviderId;
        return data;
    }
}

export interface IInitiateSignUpResponseDto {
    /** The IdentityProviderUserId of the new user (from the external system) */
    identityProviderId?: string;

    [key: string]: any;
}

export class ConfirmSignUpRequestDto implements IConfirmSignUpRequestDto {
    /** Code to confirm sign up */
    confirmationCode!: string;
    /** User id from the identity provider */
    identityProviderUserId!: string;
    /** Sign-up token from a payment that will be used to link the user */
    signUpToken?: string;
    /** The user's password */
    password?: string;

    [key: string]: any;

    constructor(data?: IConfirmSignUpRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.confirmationCode = _data["confirmationCode"];
            this.identityProviderUserId = _data["identityProviderUserId"];
            this.signUpToken = _data["signUpToken"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): ConfirmSignUpRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmSignUpRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["confirmationCode"] = this.confirmationCode;
        data["identityProviderUserId"] = this.identityProviderUserId;
        data["signUpToken"] = this.signUpToken;
        data["password"] = this.password;
        return data;
    }
}

export interface IConfirmSignUpRequestDto {
    /** Code to confirm sign up */
    confirmationCode: string;
    /** User id from the identity provider */
    identityProviderUserId: string;
    /** Sign-up token from a payment that will be used to link the user */
    signUpToken?: string;
    /** The user's password */
    password?: string;

    [key: string]: any;
}

export class SignInRequestDto implements ISignInRequestDto {
    /** Email address of user */
    email!: string;
    /** Password of user */
    password!: string;

    [key: string]: any;

    constructor(data?: ISignInRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.email = _data["email"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): SignInRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SignInRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["email"] = this.email;
        data["password"] = this.password;
        return data;
    }
}

export interface ISignInRequestDto {
    /** Email address of user */
    email: string;
    /** Password of user */
    password: string;

    [key: string]: any;
}

export class SignInResponseDto implements ISignInResponseDto {
    /** Indicates that the sign in was successful */
    succeeded!: boolean;
    /** Indicates that the user must use 2-factor authentication */
    requiresTwoFactor!: boolean;
    /** Indicates that the user must change their password */
    requiresPasswordChange!: boolean;
    /** Indicates that hte user must reset their password */
    requiresPasswordReset!: boolean;
    /** Indicates that the user must confirm the account */
    requiresConfirmation!: boolean;
    /** message with description of status */
    message?: string;

    [key: string]: any;

    constructor(data?: ISignInResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.succeeded = _data["succeeded"];
            this.requiresTwoFactor = _data["requiresTwoFactor"];
            this.requiresPasswordChange = _data["requiresPasswordChange"];
            this.requiresPasswordReset = _data["requiresPasswordReset"];
            this.requiresConfirmation = _data["requiresConfirmation"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): SignInResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SignInResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["succeeded"] = this.succeeded;
        data["requiresTwoFactor"] = this.requiresTwoFactor;
        data["requiresPasswordChange"] = this.requiresPasswordChange;
        data["requiresPasswordReset"] = this.requiresPasswordReset;
        data["requiresConfirmation"] = this.requiresConfirmation;
        data["message"] = this.message;
        return data;
    }
}

export interface ISignInResponseDto {
    /** Indicates that the sign in was successful */
    succeeded: boolean;
    /** Indicates that the user must use 2-factor authentication */
    requiresTwoFactor: boolean;
    /** Indicates that the user must change their password */
    requiresPasswordChange: boolean;
    /** Indicates that hte user must reset their password */
    requiresPasswordReset: boolean;
    /** Indicates that the user must confirm the account */
    requiresConfirmation: boolean;
    /** message with description of status */
    message?: string;

    [key: string]: any;
}

export class UserProfileDto implements IUserProfileDto {
    /** Identity server user id */
    identityProviderUserId?: string;
    /** Unique user ID */
    onlineUserId?: number;
    /** The user's email */
    email?: string;
    /** The user's email is verified */
    emailVerified?: boolean;
    /** The user's name */
    name?: string;
    /** The user's phone number */
    phoneNumber?: string;
    /** The user's phone number is verified */
    phoneNumberVerified?: boolean;

    [key: string]: any;

    constructor(data?: IUserProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.identityProviderUserId = _data["identityProviderUserId"];
            this.onlineUserId = _data["onlineUserId"];
            this.email = _data["email"];
            this.emailVerified = _data["emailVerified"];
            this.name = _data["name"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumberVerified = _data["phoneNumberVerified"];
        }
    }

    static fromJS(data: any): UserProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["identityProviderUserId"] = this.identityProviderUserId;
        data["onlineUserId"] = this.onlineUserId;
        data["email"] = this.email;
        data["emailVerified"] = this.emailVerified;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberVerified"] = this.phoneNumberVerified;
        return data;
    }
}

export interface IUserProfileDto {
    /** Identity server user id */
    identityProviderUserId?: string;
    /** Unique user ID */
    onlineUserId?: number;
    /** The user's email */
    email?: string;
    /** The user's email is verified */
    emailVerified?: boolean;
    /** The user's name */
    name?: string;
    /** The user's phone number */
    phoneNumber?: string;
    /** The user's phone number is verified */
    phoneNumberVerified?: boolean;

    [key: string]: any;
}

export class DeleteUserProfileDto implements IDeleteUserProfileDto {
    /** Message typed for confirmation */
    confirmation?: string;
    /** The user's password */
    password?: string;

    [key: string]: any;

    constructor(data?: IDeleteUserProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.confirmation = _data["confirmation"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): DeleteUserProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteUserProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["confirmation"] = this.confirmation;
        data["password"] = this.password;
        return data;
    }
}

export interface IDeleteUserProfileDto {
    /** Message typed for confirmation */
    confirmation?: string;
    /** The user's password */
    password?: string;

    [key: string]: any;
}

export class UserNotificationSettingsDto implements IUserNotificationSettingsDto {
    /** Unique user ID< */
    onlineUserId?: number;
    /** Indicates if the user has email notifications on */
    emailNotificationsOn?: boolean;
    /** The email address to be used for email notifications */
    emailForNotification?: string;
    /** Indicates if the user has SMS notifications on */
    smsNotificationsOn?: boolean;
    /** The phone number to be used for email notifications */
    phoneForSmsNotification?: string;

    [key: string]: any;

    constructor(data?: IUserNotificationSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.onlineUserId = _data["onlineUserId"];
            this.emailNotificationsOn = _data["emailNotificationsOn"];
            this.emailForNotification = _data["emailForNotification"];
            this.smsNotificationsOn = _data["smsNotificationsOn"];
            this.phoneForSmsNotification = _data["phoneForSmsNotification"];
        }
    }

    static fromJS(data: any): UserNotificationSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserNotificationSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["onlineUserId"] = this.onlineUserId;
        data["emailNotificationsOn"] = this.emailNotificationsOn;
        data["emailForNotification"] = this.emailForNotification;
        data["smsNotificationsOn"] = this.smsNotificationsOn;
        data["phoneForSmsNotification"] = this.phoneForSmsNotification;
        return data;
    }
}

export interface IUserNotificationSettingsDto {
    /** Unique user ID< */
    onlineUserId?: number;
    /** Indicates if the user has email notifications on */
    emailNotificationsOn?: boolean;
    /** The email address to be used for email notifications */
    emailForNotification?: string;
    /** Indicates if the user has SMS notifications on */
    smsNotificationsOn?: boolean;
    /** The phone number to be used for email notifications */
    phoneForSmsNotification?: string;

    [key: string]: any;
}

export class InitiatePasswordResetRequestDto implements IInitiatePasswordResetRequestDto {
    /** The user's email */
    email?: string;

    [key: string]: any;

    constructor(data?: IInitiatePasswordResetRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): InitiatePasswordResetRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new InitiatePasswordResetRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["email"] = this.email;
        return data;
    }
}

export interface IInitiatePasswordResetRequestDto {
    /** The user's email */
    email?: string;

    [key: string]: any;
}

export class ConfirmPasswordResetRequestDto implements IConfirmPasswordResetRequestDto {
    /** The user's email */
    email?: string;
    /** The user's confirmation code */
    confirmationCode?: string;
    /** The user's new password */
    newPassword?: string;

    [key: string]: any;

    constructor(data?: IConfirmPasswordResetRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.email = _data["email"];
            this.confirmationCode = _data["confirmationCode"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ConfirmPasswordResetRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmPasswordResetRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["email"] = this.email;
        data["confirmationCode"] = this.confirmationCode;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IConfirmPasswordResetRequestDto {
    /** The user's email */
    email?: string;
    /** The user's confirmation code */
    confirmationCode?: string;
    /** The user's new password */
    newPassword?: string;

    [key: string]: any;
}

export class ChangeUserPasswordDto implements IChangeUserPasswordDto {
    /** The user's email */
    email?: string;
    /** The current user's password */
    oldPassword?: string;
    /** The new user's password */
    newPassword?: string;
    /** The new user's password confirm */
    confirmPassword?: string;

    [key: string]: any;

    constructor(data?: IChangeUserPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.email = _data["email"];
            this.oldPassword = _data["oldPassword"];
            this.newPassword = _data["newPassword"];
            this.confirmPassword = _data["confirmPassword"];
        }
    }

    static fromJS(data: any): ChangeUserPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["email"] = this.email;
        data["oldPassword"] = this.oldPassword;
        data["newPassword"] = this.newPassword;
        data["confirmPassword"] = this.confirmPassword;
        return data;
    }
}

export interface IChangeUserPasswordDto {
    /** The user's email */
    email?: string;
    /** The current user's password */
    oldPassword?: string;
    /** The new user's password */
    newPassword?: string;
    /** The new user's password confirm */
    confirmPassword?: string;

    [key: string]: any;
}

export class UserPaymentHistoryDto implements IUserPaymentHistoryDto {
    /** Receipt */
    paymentMethodId?: number;
    /** Receipt */
    paymentGuid?: string;
    /** Receipt */
    receiptNo?: string;
    /** Payment date and time */
    paymentDateTime?: string;
    /** The total sum of payment */
    totalSum?: number;
    /** Payment reference (e.g. PaymentTransactionId) */
    paymentRef?: string;

    [key: string]: any;

    constructor(data?: IUserPaymentHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.paymentMethodId = _data["paymentMethodId"];
            this.paymentGuid = _data["paymentGuid"];
            this.receiptNo = _data["receiptNo"];
            this.paymentDateTime = _data["paymentDateTime"];
            this.totalSum = _data["totalSum"];
            this.paymentRef = _data["paymentRef"];
        }
    }

    static fromJS(data: any): UserPaymentHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserPaymentHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["paymentMethodId"] = this.paymentMethodId;
        data["paymentGuid"] = this.paymentGuid;
        data["receiptNo"] = this.receiptNo;
        data["paymentDateTime"] = this.paymentDateTime;
        data["totalSum"] = this.totalSum;
        data["paymentRef"] = this.paymentRef;
        return data;
    }
}

export interface IUserPaymentHistoryDto {
    /** Receipt */
    paymentMethodId?: number;
    /** Receipt */
    paymentGuid?: string;
    /** Receipt */
    receiptNo?: string;
    /** Payment date and time */
    paymentDateTime?: string;
    /** The total sum of payment */
    totalSum?: number;
    /** Payment reference (e.g. PaymentTransactionId) */
    paymentRef?: string;

    [key: string]: any;
}

export class UserProfileHistoryDto implements IUserProfileHistoryDto {
    /** The info that was changed (e.g. name, email or password) */
    infoChanged?: string;
    /** Field value before the change */
    oldValue?: string;
    /** Field value after the change */
    newValue?: string;
    /** Date and time of changes */
    changedAt?: string;
    /** Device type that was used to make changes (e.g. Laptop Windows, iOS, Mac) */
    deviceType?: string;
    /** The location the changes were made from, based on IP (e.g. Denver, CO) */
    location?: string;
    /** Who made a change (admin or user) */
    changedBy?: string;

    [key: string]: any;

    constructor(data?: IUserProfileHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.infoChanged = _data["infoChanged"];
            this.oldValue = _data["oldValue"];
            this.newValue = _data["newValue"];
            this.changedAt = _data["changedAt"];
            this.deviceType = _data["deviceType"];
            this.location = _data["location"];
            this.changedBy = _data["changedBy"];
        }
    }

    static fromJS(data: any): UserProfileHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["infoChanged"] = this.infoChanged;
        data["oldValue"] = this.oldValue;
        data["newValue"] = this.newValue;
        data["changedAt"] = this.changedAt;
        data["deviceType"] = this.deviceType;
        data["location"] = this.location;
        data["changedBy"] = this.changedBy;
        return data;
    }
}

export interface IUserProfileHistoryDto {
    /** The info that was changed (e.g. name, email or password) */
    infoChanged?: string;
    /** Field value before the change */
    oldValue?: string;
    /** Field value after the change */
    newValue?: string;
    /** Date and time of changes */
    changedAt?: string;
    /** Device type that was used to make changes (e.g. Laptop Windows, iOS, Mac) */
    deviceType?: string;
    /** The location the changes were made from, based on IP (e.g. Denver, CO) */
    location?: string;
    /** Who made a change (admin or user) */
    changedBy?: string;

    [key: string]: any;
}

export class UpdateUserPaymentInfoDto implements IUpdateUserPaymentInfoDto {
    /** Type of the change */
    updateType?: UpdateUserPaymentInfoDtoUpdateType;
    /** Credit card name and last 4 digits ( e.g. Mastercard ending in 4444) */
    creditCardName?: string;
    /** Cardholder Name (e.g. John Doe) */
    cardholderName?: string;
    /** Expiration date (e.g. 11/2024) */
    expDate?: string;
    /** eCheck Routing number */
    eCheckRoutingNum?: string;
    /** eCheck Account number */
    eCheckAccountNum?: string;
    /** eCheck Account type (1:BusinessChecking, 2:BuisnessSavings, 3:PersonalChecking, 4:PersonalSavings) */
    eCheckAccountType?: number;
    /** Address Full Name (e.g. John Doe) */
    addrFullName?: string;
    /** Address 1 Line (e.g. 27 Merry Ln) */
    addrLine1?: string;
    /** Address 2 Line (e.g. */
    addrLine2?: string;
    /** Address City (e.g. East Hanover) */
    addrCity?: string;
    /** Address State / Province / Region (e.g. NJ) */
    addrState?: string;
    /** Address Zip (e.g. 07936-3901) */
    addrZip?: string;
    /** Address Country (e.g. United States) */
    addrCountry?: string;
    /** Address Phone number (e.g. (973) 552-2630) */
    addrPhoneNum?: string;

    [key: string]: any;

    constructor(data?: IUpdateUserPaymentInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.updateType = _data["updateType"];
            this.creditCardName = _data["creditCardName"];
            this.cardholderName = _data["cardholderName"];
            this.expDate = _data["expDate"];
            this.eCheckRoutingNum = _data["eCheckRoutingNum"];
            this.eCheckAccountNum = _data["eCheckAccountNum"];
            this.eCheckAccountType = _data["eCheckAccountType"];
            this.addrFullName = _data["addrFullName"];
            this.addrLine1 = _data["addrLine1"];
            this.addrLine2 = _data["addrLine2"];
            this.addrCity = _data["addrCity"];
            this.addrState = _data["addrState"];
            this.addrZip = _data["addrZip"];
            this.addrCountry = _data["addrCountry"];
            this.addrPhoneNum = _data["addrPhoneNum"];
        }
    }

    static fromJS(data: any): UpdateUserPaymentInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserPaymentInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["updateType"] = this.updateType;
        data["creditCardName"] = this.creditCardName;
        data["cardholderName"] = this.cardholderName;
        data["expDate"] = this.expDate;
        data["eCheckRoutingNum"] = this.eCheckRoutingNum;
        data["eCheckAccountNum"] = this.eCheckAccountNum;
        data["eCheckAccountType"] = this.eCheckAccountType;
        data["addrFullName"] = this.addrFullName;
        data["addrLine1"] = this.addrLine1;
        data["addrLine2"] = this.addrLine2;
        data["addrCity"] = this.addrCity;
        data["addrState"] = this.addrState;
        data["addrZip"] = this.addrZip;
        data["addrCountry"] = this.addrCountry;
        data["addrPhoneNum"] = this.addrPhoneNum;
        return data;
    }
}

export interface IUpdateUserPaymentInfoDto {
    /** Type of the change */
    updateType?: UpdateUserPaymentInfoDtoUpdateType;
    /** Credit card name and last 4 digits ( e.g. Mastercard ending in 4444) */
    creditCardName?: string;
    /** Cardholder Name (e.g. John Doe) */
    cardholderName?: string;
    /** Expiration date (e.g. 11/2024) */
    expDate?: string;
    /** eCheck Routing number */
    eCheckRoutingNum?: string;
    /** eCheck Account number */
    eCheckAccountNum?: string;
    /** eCheck Account type (1:BusinessChecking, 2:BuisnessSavings, 3:PersonalChecking, 4:PersonalSavings) */
    eCheckAccountType?: number;
    /** Address Full Name (e.g. John Doe) */
    addrFullName?: string;
    /** Address 1 Line (e.g. 27 Merry Ln) */
    addrLine1?: string;
    /** Address 2 Line (e.g. */
    addrLine2?: string;
    /** Address City (e.g. East Hanover) */
    addrCity?: string;
    /** Address State / Province / Region (e.g. NJ) */
    addrState?: string;
    /** Address Zip (e.g. 07936-3901) */
    addrZip?: string;
    /** Address Country (e.g. United States) */
    addrCountry?: string;
    /** Address Phone number (e.g. (973) 552-2630) */
    addrPhoneNum?: string;

    [key: string]: any;
}

export class ResendEmailConfirmationRequestDto implements IResendEmailConfirmationRequestDto {
    /** The user's email */
    email?: string;
    requestType?: ConfirmCodeRequestTypeEnumDto;

    [key: string]: any;

    constructor(data?: IResendEmailConfirmationRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.email = _data["email"];
            this.requestType = _data["requestType"];
        }
    }

    static fromJS(data: any): ResendEmailConfirmationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResendEmailConfirmationRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["email"] = this.email;
        data["requestType"] = this.requestType;
        return data;
    }
}

export interface IResendEmailConfirmationRequestDto {
    /** The user's email */
    email?: string;
    requestType?: ConfirmCodeRequestTypeEnumDto;

    [key: string]: any;
}

export class ConfirmPhoneCodeRequestDto implements IConfirmPhoneCodeRequestDto {
    /** The user's confirmation code */
    confirmationCode?: string;

    [key: string]: any;

    constructor(data?: IConfirmPhoneCodeRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.confirmationCode = _data["confirmationCode"];
        }
    }

    static fromJS(data: any): ConfirmPhoneCodeRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmPhoneCodeRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["confirmationCode"] = this.confirmationCode;
        return data;
    }
}

export interface IConfirmPhoneCodeRequestDto {
    /** The user's confirmation code */
    confirmationCode?: string;

    [key: string]: any;
}

export class ConfirmEmailCodeDto implements IConfirmEmailCodeDto {
    /** The user's confirmation code */
    confirmationCode?: string;

    [key: string]: any;

    constructor(data?: IConfirmEmailCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.confirmationCode = _data["confirmationCode"];
        }
    }

    static fromJS(data: any): ConfirmEmailCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmEmailCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["confirmationCode"] = this.confirmationCode;
        return data;
    }
}

export interface IConfirmEmailCodeDto {
    /** The user's confirmation code */
    confirmationCode?: string;

    [key: string]: any;
}

/** Which type of request for a code this is - SignUp, ForgotPassword, Email, or Phone */
export enum ConfirmCodeRequestTypeEnumDto {
    SignUp = "signUp",
    ForgotPassword = "forgotPassword",
    Email = "email",
    Phone = "phone",
}

export class ErrorDto implements IErrorDto {
    /** Error message to display to the user */
    errorMessage!: string;
    /** Random number to help correlate the error log with what the user sees.
Prefix "S" is for Server error; "C" is for Client error.
 */
    errorNumber!: string;
    /** Error def identifying the error */
    errorDef!: string;
    /** Error details for troubleshooting/development */
    errorDetails?: string;
    /** Prompt the user with a modal dialog with this message. */
    prompt?: boolean;

    [key: string]: any;

    constructor(data?: IErrorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.errorMessage = _data["errorMessage"];
            this.errorNumber = _data["errorNumber"];
            this.errorDef = _data["errorDef"];
            this.errorDetails = _data["errorDetails"];
            this.prompt = _data["prompt"];
        }
    }

    static fromJS(data: any): ErrorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["errorMessage"] = this.errorMessage;
        data["errorNumber"] = this.errorNumber;
        data["errorDef"] = this.errorDef;
        data["errorDetails"] = this.errorDetails;
        data["prompt"] = this.prompt;
        return data;
    }
}

export interface IErrorDto {
    /** Error message to display to the user */
    errorMessage: string;
    /** Random number to help correlate the error log with what the user sees.
Prefix "S" is for Server error; "C" is for Client error.
 */
    errorNumber: string;
    /** Error def identifying the error */
    errorDef: string;
    /** Error details for troubleshooting/development */
    errorDetails?: string;
    /** Prompt the user with a modal dialog with this message. */
    prompt?: boolean;

    [key: string]: any;
}

export enum UpdateUserPaymentInfoDtoUpdateType {
    CreditCard = "CreditCard",
    ECheck = "eCheck",
}

export class IdentityApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isIdentityApiException = true;

    static isIdentityApiException(obj: any): obj is IdentityApiException {
        return obj.isIdentityApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new IdentityApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}